import { membersApi, OtpResponse } from '@/api/members.api';
import { ApiError } from '@/api/baseApi';
import { useMutation } from '@tanstack/react-query';
import { PaymentSummaryData, PaymentSuccessResponse } from '@/components/blocks/ChargeMember/types';

export interface PaymentBreakdownRequest {
  memberId: string;
  locationId: string;
  amountToPay: number;
  tipAmount: number;
  note?: string;
}

export interface VerifyOtpRequest {
  otpPaymentId: string;
  otpCode: string;
  locationId: string;
}

export const usePaymentBreakdownMutation = () => {
  return useMutation<PaymentSummaryData, Error, PaymentBreakdownRequest>({
    mutationFn: membersApi.getPaymentBreakdown,
  });
};

export const useRequestOtpMutation = () => {
  return useMutation<OtpResponse, Error, PaymentBreakdownRequest>({
    mutationFn: membersApi.requestOtp,
  });
};

export const useVerifyOtpMutation = () => {
  return useMutation<PaymentSuccessResponse, ApiError | Error, VerifyOtpRequest>({
    mutationFn: membersApi.verifyOtp,
  });
}; 